import * as React from 'react'
import { useMemo } from 'react'
import BaseDisbursementOverview, {
    BaseDisbursementLineOverviewProps,
    BaseDisbursementOverviewProps,
    DisbursementFilterType,
} from './BaseDisbursementOverview'
import DisbursementListItem from './DisbursementListItem'

export type FileDisbursementOverviewProps = Partial<BaseDisbursementOverviewProps> & {
    baseUrl: string
    fileId: string
    localStorageKeyPrefix?: string
}

/**
 * The disbursement overview within a dossier (HAM-3627): the disbursements of the file. All data
 * loading, the filter, the create button and the add/edit popup come from BaseDisbursementOverview;
 * this wrapper only scopes to the file (hiding the redundant file filter).
 */
export default function DisbursementOverview(props: FileDisbursementOverviewProps) {
    const fixedFilterValues = useMemo<Partial<DisbursementFilterType>>(
        () => ({ files: props.fileId ? [props.fileId] : undefined }),
        [props.fileId],
    )

    return (
        <BaseDisbursementOverview
            {...props}
            fixedFilterValues={fixedFilterValues}
            hideFileField={!!props.fileId}
            listItemContent={(itemProps: BaseDisbursementLineOverviewProps) => (
                <DisbursementListItem {...itemProps} hideFileField renderLink={false} />
            )}
        />
    )
}
